/* tslint:disable */
/* eslint-disable */
/**
 * Viewup Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../../base';
// @ts-ignore
import type { DeleteCommentByCommentUuidForbiddenDto } from '../../src/model';
// @ts-ignore
import type { DeleteCommentByCommentUuidInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { DeleteCommentByCommentUuidNotFoundCommentDto } from '../../src/model';
// @ts-ignore
import type { DeleteLikeByPostUuidForbiddenDto } from '../../src/model';
// @ts-ignore
import type { DeleteLikeByPostUuidInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { DeleteLikeByPostUuidNotFoundLikeDto } from '../../src/model';
// @ts-ignore
import type { DeleteLikeByPostUuidNotFoundPostDto } from '../../src/model';
// @ts-ignore
import type { DeletePostByPostUuidForbiddenDto } from '../../src/model';
// @ts-ignore
import type { DeletePostByPostUuidInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { DeletePostByPostUuidNotFoundDto } from '../../src/model';
// @ts-ignore
import type { GetBestTipPostsInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { GetBestTipPostsOkDto } from '../../src/model';
// @ts-ignore
import type { GetCommentsByUserUuidInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { GetCommentsByUserUuidOkDto } from '../../src/model';
// @ts-ignore
import type { GetCommentsInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { GetCommentsNotFoundPostDto } from '../../src/model';
// @ts-ignore
import type { GetCommentsOkDto } from '../../src/model';
// @ts-ignore
import type { GetCommunitiesInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { GetCommunitiesOkDto } from '../../src/model';
// @ts-ignore
import type { GetLatestLikesInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { GetLatestLikesNotFoundDto } from '../../src/model';
// @ts-ignore
import type { GetLatestLikesOkDto } from '../../src/model';
// @ts-ignore
import type { GetLikeStatusByPostUuidInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { GetLikeStatusByPostUuidNotFoundDto } from '../../src/model';
// @ts-ignore
import type { GetLikeStatusByPostUuidOkDto } from '../../src/model';
// @ts-ignore
import type { GetPinnedPostsInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { GetPinnedPostsOkDto } from '../../src/model';
// @ts-ignore
import type { GetPopularPostsInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { GetPopularPostsOkDto } from '../../src/model';
// @ts-ignore
import type { GetPostByPostUuidInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { GetPostByPostUuidNotFoundDto } from '../../src/model';
// @ts-ignore
import type { GetPostByPostUuidOkDto } from '../../src/model';
// @ts-ignore
import type { GetPostsByCommunityUuidNotFoundDto } from '../../src/model';
// @ts-ignore
import type { GetPostsInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { GetPostsOkDto } from '../../src/model';
// @ts-ignore
import type { GetRecommendedPostsInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { GetRecommendedPostsOkDto } from '../../src/model';
// @ts-ignore
import type { GetRelatedPostsByPostUuidInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { GetRelatedPostsByPostUuidNotFoundDto } from '../../src/model';
// @ts-ignore
import type { GetRelatedPostsByPostUuidOkDto } from '../../src/model';
// @ts-ignore
import type { JwtAccessGuardUnauthorizedDto } from '../../src/model';
// @ts-ignore
import type { PatchCommentByCommentUuidForbiddenDto } from '../../src/model';
// @ts-ignore
import type { PatchCommentByCommentUuidInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { PatchCommentByCommentUuidNotFoundCommentDto } from '../../src/model';
// @ts-ignore
import type { PatchCommentByCommentUuidOkDto } from '../../src/model';
// @ts-ignore
import type { PatchCommentByCommentUuidReqBodyDto } from '../../src/model';
// @ts-ignore
import type { PatchPostByPostUuidForbiddenCategoryDto } from '../../src/model';
// @ts-ignore
import type { PatchPostByPostUuidForbiddenUserDto } from '../../src/model';
// @ts-ignore
import type { PatchPostByPostUuidInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { PatchPostByPostUuidNotFoundCommunityDto } from '../../src/model';
// @ts-ignore
import type { PatchPostByPostUuidNotFoundPostDto } from '../../src/model';
// @ts-ignore
import type { PatchPostByPostUuidOkDto } from '../../src/model';
// @ts-ignore
import type { PatchPostByPostUuidReqBodyDto } from '../../src/model';
// @ts-ignore
import type { PostCommentByPostUuidCreatedDto } from '../../src/model';
// @ts-ignore
import type { PostCommentByPostUuidInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { PostCommentByPostUuidNotFoundCommentDto } from '../../src/model';
// @ts-ignore
import type { PostCommentByPostUuidNotFoundPostDto } from '../../src/model';
// @ts-ignore
import type { PostCommentByPostUuidReqBodyDto } from '../../src/model';
// @ts-ignore
import type { PostLikeByPostUuidConflictDto } from '../../src/model';
// @ts-ignore
import type { PostLikeByPostUuidCreatedDto } from '../../src/model';
// @ts-ignore
import type { PostLikeByPostUuidInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { PostLikeByPostUuidNotFoundDto } from '../../src/model';
// @ts-ignore
import type { PostPostByCommunityUuidCreatedDto } from '../../src/model';
// @ts-ignore
import type { PostPostByCommunityUuidForbiddenDto } from '../../src/model';
// @ts-ignore
import type { PostPostByCommunityUuidInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { PostPostByCommunityUuidNotFoundDto } from '../../src/model';
// @ts-ignore
import type { PostPostByCommunityUuidReqBodyDto } from '../../src/model';
/**
 * CommunitiesApi - axios parameter creator
 * @export
 */
export const CommunitiesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 커뮤니티 게시글 댓글 삭제
         * @param {string} communityPostCommentUuid 댓글 uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communityControllerDeleteCommentByCommentUuid: async (communityPostCommentUuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communityPostCommentUuid' is not null or undefined
            assertParamExists('communityControllerDeleteCommentByCommentUuid', 'communityPostCommentUuid', communityPostCommentUuid)
            const localVarPath = `/communities/posts/comments/{communityPostCommentUuid}`
                .replace(`{${"communityPostCommentUuid"}}`, encodeURIComponent(String(communityPostCommentUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 커뮤니티 게시글 좋아요 삭제
         * @param {string} communityPostUuid 게시글 uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communityControllerDeleteLikeByPostUuid: async (communityPostUuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communityPostUuid' is not null or undefined
            assertParamExists('communityControllerDeleteLikeByPostUuid', 'communityPostUuid', communityPostUuid)
            const localVarPath = `/communities/posts/{communityPostUuid}/likes`
                .replace(`{${"communityPostUuid"}}`, encodeURIComponent(String(communityPostUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 커뮤니티 게시글 삭제
         * @param {string} communityPostUuid 게시글 uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communityControllerDeletePostByPostUuid: async (communityPostUuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communityPostUuid' is not null or undefined
            assertParamExists('communityControllerDeletePostByPostUuid', 'communityPostUuid', communityPostUuid)
            const localVarPath = `/communities/posts/{communityPostUuid}`
                .replace(`{${"communityPostUuid"}}`, encodeURIComponent(String(communityPostUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 커뮤니티 베스트 꿀팁 게시글 목록 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communityControllerGetBestTipPosts: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/communities/posts/best-tip`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 커뮤니티 게시글 댓글 목록 조회
         * @param {string} communityPostUuid 게시글 uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communityControllerGetCommentsByPostUuid: async (communityPostUuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communityPostUuid' is not null or undefined
            assertParamExists('communityControllerGetCommentsByPostUuid', 'communityPostUuid', communityPostUuid)
            const localVarPath = `/communities/posts/{communityPostUuid}/comments`
                .replace(`{${"communityPostUuid"}}`, encodeURIComponent(String(communityPostUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 커뮤니티 게시글 본인 댓글 조회
         * @param {number} [page] 현재 페이지
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communityControllerGetCommentsByUserUuid: async (page?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/communities/posts/comments/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 커뮤니티 카테고리 목록 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communityControllerGetCommunities: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/communities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 커뮤니티 게시글 최근 3개 좋아요 목록 조회
         * @param {string} communityPostUuid 게시글 uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communityControllerGetLatestLikesByPostUuid: async (communityPostUuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communityPostUuid' is not null or undefined
            assertParamExists('communityControllerGetLatestLikesByPostUuid', 'communityPostUuid', communityPostUuid)
            const localVarPath = `/communities/posts/{communityPostUuid}/likes/latest`
                .replace(`{${"communityPostUuid"}}`, encodeURIComponent(String(communityPostUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 커뮤니티 게시글에 본인이 좋아요 했는지 확인
         * @param {string} communityPostUuid 게시글 uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communityControllerGetLikeStatusByPostUuid: async (communityPostUuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communityPostUuid' is not null or undefined
            assertParamExists('communityControllerGetLikeStatusByPostUuid', 'communityPostUuid', communityPostUuid)
            const localVarPath = `/communities/posts/{communityPostUuid}/likes/status`
                .replace(`{${"communityPostUuid"}}`, encodeURIComponent(String(communityPostUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 커뮤니티 상단고정 게시글 목록 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communityControllerGetPinnedPosts: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/communities/posts/pinned`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 커뮤니티 인기 게시글 목록 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communityControllerGetPopularPosts: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/communities/posts/popular`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 커뮤니티 게시글 조회
         * @param {string} communityPostUuid 게시글 uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communityControllerGetPostByPostUuid: async (communityPostUuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communityPostUuid' is not null or undefined
            assertParamExists('communityControllerGetPostByPostUuid', 'communityPostUuid', communityPostUuid)
            const localVarPath = `/communities/posts/{communityPostUuid}`
                .replace(`{${"communityPostUuid"}}`, encodeURIComponent(String(communityPostUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 커뮤니티 게시글 목록 조회
         * @param {number} [page] 현재 페이지
         * @param {number} [limit] 한 페이지에 보여줄 데이터 수
         * @param {CommunityControllerGetPostsSortEnum} [sort] 정렬 기준
         * @param {CommunityControllerGetPostsSearchTypeEnum} [searchType] 검색 타입
         * @param {string} [keyword] 검색어
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communityControllerGetPosts: async (page?: number, limit?: number, sort?: CommunityControllerGetPostsSortEnum, searchType?: CommunityControllerGetPostsSearchTypeEnum, keyword?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/communities/posts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (searchType !== undefined) {
                localVarQueryParameter['searchType'] = searchType;
            }

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 특정 커뮤니티(카테고리) 게시글 목록 조회
         * @param {string} communityUuid 커뮤니티 uuid(카테고리)
         * @param {number} [page] 현재 페이지
         * @param {number} [limit] 한 페이지에 보여줄 데이터 수
         * @param {CommunityControllerGetPostsByCommunityUuidSortEnum} [sort] 정렬 기준
         * @param {CommunityControllerGetPostsByCommunityUuidSearchTypeEnum} [searchType] 검색 타입
         * @param {string} [keyword] 검색어
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communityControllerGetPostsByCommunityUuid: async (communityUuid: string, page?: number, limit?: number, sort?: CommunityControllerGetPostsByCommunityUuidSortEnum, searchType?: CommunityControllerGetPostsByCommunityUuidSearchTypeEnum, keyword?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communityUuid' is not null or undefined
            assertParamExists('communityControllerGetPostsByCommunityUuid', 'communityUuid', communityUuid)
            const localVarPath = `/communities/{communityUuid}/posts`
                .replace(`{${"communityUuid"}}`, encodeURIComponent(String(communityUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (searchType !== undefined) {
                localVarQueryParameter['searchType'] = searchType;
            }

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 커뮤니티 추천 게시글 목록 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communityControllerGetRecommendedPosts: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/communities/posts/recommended`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 커뮤니티 같은 카테고리의 게시글 3개 조회
         * @param {string} communityPostUuid 게시글 uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communityControllerGetRelatedPostsByPostUuid: async (communityPostUuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communityPostUuid' is not null or undefined
            assertParamExists('communityControllerGetRelatedPostsByPostUuid', 'communityPostUuid', communityPostUuid)
            const localVarPath = `/communities/posts/{communityPostUuid}/related`
                .replace(`{${"communityPostUuid"}}`, encodeURIComponent(String(communityPostUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 커뮤니티 게시글 댓글 수정
         * @param {string} communityPostCommentUuid 댓글 uuid
         * @param {PatchCommentByCommentUuidReqBodyDto} patchCommentByCommentUuidReqBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communityControllerPatchCommentByCommentUuid: async (communityPostCommentUuid: string, patchCommentByCommentUuidReqBodyDto: PatchCommentByCommentUuidReqBodyDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communityPostCommentUuid' is not null or undefined
            assertParamExists('communityControllerPatchCommentByCommentUuid', 'communityPostCommentUuid', communityPostCommentUuid)
            // verify required parameter 'patchCommentByCommentUuidReqBodyDto' is not null or undefined
            assertParamExists('communityControllerPatchCommentByCommentUuid', 'patchCommentByCommentUuidReqBodyDto', patchCommentByCommentUuidReqBodyDto)
            const localVarPath = `/communities/posts/comments/{communityPostCommentUuid}`
                .replace(`{${"communityPostCommentUuid"}}`, encodeURIComponent(String(communityPostCommentUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchCommentByCommentUuidReqBodyDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 커뮤니티 게시글 수정
         * @param {string} communityPostUuid 게시글 uuid
         * @param {PatchPostByPostUuidReqBodyDto} patchPostByPostUuidReqBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communityControllerPatchPostByPostUuid: async (communityPostUuid: string, patchPostByPostUuidReqBodyDto: PatchPostByPostUuidReqBodyDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communityPostUuid' is not null or undefined
            assertParamExists('communityControllerPatchPostByPostUuid', 'communityPostUuid', communityPostUuid)
            // verify required parameter 'patchPostByPostUuidReqBodyDto' is not null or undefined
            assertParamExists('communityControllerPatchPostByPostUuid', 'patchPostByPostUuidReqBodyDto', patchPostByPostUuidReqBodyDto)
            const localVarPath = `/communities/posts/{communityPostUuid}`
                .replace(`{${"communityPostUuid"}}`, encodeURIComponent(String(communityPostUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchPostByPostUuidReqBodyDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 커뮤니티 게시글 댓글 생성
         * @param {string} communityPostUuid 게시글 uuid
         * @param {PostCommentByPostUuidReqBodyDto} postCommentByPostUuidReqBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communityControllerPostCommentByPostUuid: async (communityPostUuid: string, postCommentByPostUuidReqBodyDto: PostCommentByPostUuidReqBodyDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communityPostUuid' is not null or undefined
            assertParamExists('communityControllerPostCommentByPostUuid', 'communityPostUuid', communityPostUuid)
            // verify required parameter 'postCommentByPostUuidReqBodyDto' is not null or undefined
            assertParamExists('communityControllerPostCommentByPostUuid', 'postCommentByPostUuidReqBodyDto', postCommentByPostUuidReqBodyDto)
            const localVarPath = `/communities/posts/{communityPostUuid}/comments`
                .replace(`{${"communityPostUuid"}}`, encodeURIComponent(String(communityPostUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postCommentByPostUuidReqBodyDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 커뮤니티 게시글 좋아요 생성
         * @param {string} communityPostUuid 게시글 uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communityControllerPostLikeByPostUuid: async (communityPostUuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communityPostUuid' is not null or undefined
            assertParamExists('communityControllerPostLikeByPostUuid', 'communityPostUuid', communityPostUuid)
            const localVarPath = `/communities/posts/{communityPostUuid}/likes`
                .replace(`{${"communityPostUuid"}}`, encodeURIComponent(String(communityPostUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 커뮤니티 게시글 생성
         * @param {string} communityUuid 커뮤니티 uuid(카테고리)
         * @param {PostPostByCommunityUuidReqBodyDto} postPostByCommunityUuidReqBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communityControllerPostPostByCommunityUuid: async (communityUuid: string, postPostByCommunityUuidReqBodyDto: PostPostByCommunityUuidReqBodyDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communityUuid' is not null or undefined
            assertParamExists('communityControllerPostPostByCommunityUuid', 'communityUuid', communityUuid)
            // verify required parameter 'postPostByCommunityUuidReqBodyDto' is not null or undefined
            assertParamExists('communityControllerPostPostByCommunityUuid', 'postPostByCommunityUuidReqBodyDto', postPostByCommunityUuidReqBodyDto)
            const localVarPath = `/communities/{communityUuid}/posts`
                .replace(`{${"communityUuid"}}`, encodeURIComponent(String(communityUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postPostByCommunityUuidReqBodyDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CommunitiesApi - functional programming interface
 * @export
 */
export const CommunitiesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CommunitiesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 커뮤니티 게시글 댓글 삭제
         * @param {string} communityPostCommentUuid 댓글 uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communityControllerDeleteCommentByCommentUuid(communityPostCommentUuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communityControllerDeleteCommentByCommentUuid(communityPostCommentUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommunitiesApi.communityControllerDeleteCommentByCommentUuid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 커뮤니티 게시글 좋아요 삭제
         * @param {string} communityPostUuid 게시글 uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communityControllerDeleteLikeByPostUuid(communityPostUuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communityControllerDeleteLikeByPostUuid(communityPostUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommunitiesApi.communityControllerDeleteLikeByPostUuid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 커뮤니티 게시글 삭제
         * @param {string} communityPostUuid 게시글 uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communityControllerDeletePostByPostUuid(communityPostUuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communityControllerDeletePostByPostUuid(communityPostUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommunitiesApi.communityControllerDeletePostByPostUuid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 커뮤니티 베스트 꿀팁 게시글 목록 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communityControllerGetBestTipPosts(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetBestTipPostsOkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communityControllerGetBestTipPosts(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommunitiesApi.communityControllerGetBestTipPosts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 커뮤니티 게시글 댓글 목록 조회
         * @param {string} communityPostUuid 게시글 uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communityControllerGetCommentsByPostUuid(communityPostUuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCommentsOkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communityControllerGetCommentsByPostUuid(communityPostUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommunitiesApi.communityControllerGetCommentsByPostUuid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 커뮤니티 게시글 본인 댓글 조회
         * @param {number} [page] 현재 페이지
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communityControllerGetCommentsByUserUuid(page?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCommentsByUserUuidOkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communityControllerGetCommentsByUserUuid(page, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommunitiesApi.communityControllerGetCommentsByUserUuid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 커뮤니티 카테고리 목록 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communityControllerGetCommunities(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCommunitiesOkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communityControllerGetCommunities(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommunitiesApi.communityControllerGetCommunities']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 커뮤니티 게시글 최근 3개 좋아요 목록 조회
         * @param {string} communityPostUuid 게시글 uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communityControllerGetLatestLikesByPostUuid(communityPostUuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetLatestLikesOkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communityControllerGetLatestLikesByPostUuid(communityPostUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommunitiesApi.communityControllerGetLatestLikesByPostUuid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 커뮤니티 게시글에 본인이 좋아요 했는지 확인
         * @param {string} communityPostUuid 게시글 uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communityControllerGetLikeStatusByPostUuid(communityPostUuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetLikeStatusByPostUuidOkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communityControllerGetLikeStatusByPostUuid(communityPostUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommunitiesApi.communityControllerGetLikeStatusByPostUuid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 커뮤니티 상단고정 게시글 목록 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communityControllerGetPinnedPosts(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPinnedPostsOkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communityControllerGetPinnedPosts(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommunitiesApi.communityControllerGetPinnedPosts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 커뮤니티 인기 게시글 목록 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communityControllerGetPopularPosts(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPopularPostsOkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communityControllerGetPopularPosts(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommunitiesApi.communityControllerGetPopularPosts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 커뮤니티 게시글 조회
         * @param {string} communityPostUuid 게시글 uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communityControllerGetPostByPostUuid(communityPostUuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPostByPostUuidOkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communityControllerGetPostByPostUuid(communityPostUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommunitiesApi.communityControllerGetPostByPostUuid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 커뮤니티 게시글 목록 조회
         * @param {number} [page] 현재 페이지
         * @param {number} [limit] 한 페이지에 보여줄 데이터 수
         * @param {CommunityControllerGetPostsSortEnum} [sort] 정렬 기준
         * @param {CommunityControllerGetPostsSearchTypeEnum} [searchType] 검색 타입
         * @param {string} [keyword] 검색어
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communityControllerGetPosts(page?: number, limit?: number, sort?: CommunityControllerGetPostsSortEnum, searchType?: CommunityControllerGetPostsSearchTypeEnum, keyword?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPostsOkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communityControllerGetPosts(page, limit, sort, searchType, keyword, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommunitiesApi.communityControllerGetPosts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 특정 커뮤니티(카테고리) 게시글 목록 조회
         * @param {string} communityUuid 커뮤니티 uuid(카테고리)
         * @param {number} [page] 현재 페이지
         * @param {number} [limit] 한 페이지에 보여줄 데이터 수
         * @param {CommunityControllerGetPostsByCommunityUuidSortEnum} [sort] 정렬 기준
         * @param {CommunityControllerGetPostsByCommunityUuidSearchTypeEnum} [searchType] 검색 타입
         * @param {string} [keyword] 검색어
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communityControllerGetPostsByCommunityUuid(communityUuid: string, page?: number, limit?: number, sort?: CommunityControllerGetPostsByCommunityUuidSortEnum, searchType?: CommunityControllerGetPostsByCommunityUuidSearchTypeEnum, keyword?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPostsOkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communityControllerGetPostsByCommunityUuid(communityUuid, page, limit, sort, searchType, keyword, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommunitiesApi.communityControllerGetPostsByCommunityUuid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 커뮤니티 추천 게시글 목록 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communityControllerGetRecommendedPosts(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetRecommendedPostsOkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communityControllerGetRecommendedPosts(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommunitiesApi.communityControllerGetRecommendedPosts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 커뮤니티 같은 카테고리의 게시글 3개 조회
         * @param {string} communityPostUuid 게시글 uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communityControllerGetRelatedPostsByPostUuid(communityPostUuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetRelatedPostsByPostUuidOkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communityControllerGetRelatedPostsByPostUuid(communityPostUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommunitiesApi.communityControllerGetRelatedPostsByPostUuid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 커뮤니티 게시글 댓글 수정
         * @param {string} communityPostCommentUuid 댓글 uuid
         * @param {PatchCommentByCommentUuidReqBodyDto} patchCommentByCommentUuidReqBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communityControllerPatchCommentByCommentUuid(communityPostCommentUuid: string, patchCommentByCommentUuidReqBodyDto: PatchCommentByCommentUuidReqBodyDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PatchCommentByCommentUuidOkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communityControllerPatchCommentByCommentUuid(communityPostCommentUuid, patchCommentByCommentUuidReqBodyDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommunitiesApi.communityControllerPatchCommentByCommentUuid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 커뮤니티 게시글 수정
         * @param {string} communityPostUuid 게시글 uuid
         * @param {PatchPostByPostUuidReqBodyDto} patchPostByPostUuidReqBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communityControllerPatchPostByPostUuid(communityPostUuid: string, patchPostByPostUuidReqBodyDto: PatchPostByPostUuidReqBodyDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PatchPostByPostUuidOkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communityControllerPatchPostByPostUuid(communityPostUuid, patchPostByPostUuidReqBodyDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommunitiesApi.communityControllerPatchPostByPostUuid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 커뮤니티 게시글 댓글 생성
         * @param {string} communityPostUuid 게시글 uuid
         * @param {PostCommentByPostUuidReqBodyDto} postCommentByPostUuidReqBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communityControllerPostCommentByPostUuid(communityPostUuid: string, postCommentByPostUuidReqBodyDto: PostCommentByPostUuidReqBodyDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostCommentByPostUuidCreatedDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communityControllerPostCommentByPostUuid(communityPostUuid, postCommentByPostUuidReqBodyDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommunitiesApi.communityControllerPostCommentByPostUuid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 커뮤니티 게시글 좋아요 생성
         * @param {string} communityPostUuid 게시글 uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communityControllerPostLikeByPostUuid(communityPostUuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostLikeByPostUuidCreatedDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communityControllerPostLikeByPostUuid(communityPostUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommunitiesApi.communityControllerPostLikeByPostUuid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 커뮤니티 게시글 생성
         * @param {string} communityUuid 커뮤니티 uuid(카테고리)
         * @param {PostPostByCommunityUuidReqBodyDto} postPostByCommunityUuidReqBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communityControllerPostPostByCommunityUuid(communityUuid: string, postPostByCommunityUuidReqBodyDto: PostPostByCommunityUuidReqBodyDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostPostByCommunityUuidCreatedDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communityControllerPostPostByCommunityUuid(communityUuid, postPostByCommunityUuidReqBodyDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommunitiesApi.communityControllerPostPostByCommunityUuid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CommunitiesApi - factory interface
 * @export
 */
export const CommunitiesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CommunitiesApiFp(configuration)
    return {
        /**
         * 
         * @summary 커뮤니티 게시글 댓글 삭제
         * @param {CommunitiesApiCommunityControllerDeleteCommentByCommentUuidRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communityControllerDeleteCommentByCommentUuid(requestParameters: CommunitiesApiCommunityControllerDeleteCommentByCommentUuidRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.communityControllerDeleteCommentByCommentUuid(requestParameters.communityPostCommentUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 커뮤니티 게시글 좋아요 삭제
         * @param {CommunitiesApiCommunityControllerDeleteLikeByPostUuidRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communityControllerDeleteLikeByPostUuid(requestParameters: CommunitiesApiCommunityControllerDeleteLikeByPostUuidRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.communityControllerDeleteLikeByPostUuid(requestParameters.communityPostUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 커뮤니티 게시글 삭제
         * @param {CommunitiesApiCommunityControllerDeletePostByPostUuidRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communityControllerDeletePostByPostUuid(requestParameters: CommunitiesApiCommunityControllerDeletePostByPostUuidRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.communityControllerDeletePostByPostUuid(requestParameters.communityPostUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 커뮤니티 베스트 꿀팁 게시글 목록 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communityControllerGetBestTipPosts(options?: RawAxiosRequestConfig): AxiosPromise<GetBestTipPostsOkDto> {
            return localVarFp.communityControllerGetBestTipPosts(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 커뮤니티 게시글 댓글 목록 조회
         * @param {CommunitiesApiCommunityControllerGetCommentsByPostUuidRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communityControllerGetCommentsByPostUuid(requestParameters: CommunitiesApiCommunityControllerGetCommentsByPostUuidRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetCommentsOkDto> {
            return localVarFp.communityControllerGetCommentsByPostUuid(requestParameters.communityPostUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 커뮤니티 게시글 본인 댓글 조회
         * @param {CommunitiesApiCommunityControllerGetCommentsByUserUuidRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communityControllerGetCommentsByUserUuid(requestParameters: CommunitiesApiCommunityControllerGetCommentsByUserUuidRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetCommentsByUserUuidOkDto> {
            return localVarFp.communityControllerGetCommentsByUserUuid(requestParameters.page, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 커뮤니티 카테고리 목록 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communityControllerGetCommunities(options?: RawAxiosRequestConfig): AxiosPromise<GetCommunitiesOkDto> {
            return localVarFp.communityControllerGetCommunities(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 커뮤니티 게시글 최근 3개 좋아요 목록 조회
         * @param {CommunitiesApiCommunityControllerGetLatestLikesByPostUuidRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communityControllerGetLatestLikesByPostUuid(requestParameters: CommunitiesApiCommunityControllerGetLatestLikesByPostUuidRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetLatestLikesOkDto> {
            return localVarFp.communityControllerGetLatestLikesByPostUuid(requestParameters.communityPostUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 커뮤니티 게시글에 본인이 좋아요 했는지 확인
         * @param {CommunitiesApiCommunityControllerGetLikeStatusByPostUuidRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communityControllerGetLikeStatusByPostUuid(requestParameters: CommunitiesApiCommunityControllerGetLikeStatusByPostUuidRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetLikeStatusByPostUuidOkDto> {
            return localVarFp.communityControllerGetLikeStatusByPostUuid(requestParameters.communityPostUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 커뮤니티 상단고정 게시글 목록 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communityControllerGetPinnedPosts(options?: RawAxiosRequestConfig): AxiosPromise<GetPinnedPostsOkDto> {
            return localVarFp.communityControllerGetPinnedPosts(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 커뮤니티 인기 게시글 목록 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communityControllerGetPopularPosts(options?: RawAxiosRequestConfig): AxiosPromise<GetPopularPostsOkDto> {
            return localVarFp.communityControllerGetPopularPosts(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 커뮤니티 게시글 조회
         * @param {CommunitiesApiCommunityControllerGetPostByPostUuidRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communityControllerGetPostByPostUuid(requestParameters: CommunitiesApiCommunityControllerGetPostByPostUuidRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetPostByPostUuidOkDto> {
            return localVarFp.communityControllerGetPostByPostUuid(requestParameters.communityPostUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 커뮤니티 게시글 목록 조회
         * @param {CommunitiesApiCommunityControllerGetPostsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communityControllerGetPosts(requestParameters: CommunitiesApiCommunityControllerGetPostsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetPostsOkDto> {
            return localVarFp.communityControllerGetPosts(requestParameters.page, requestParameters.limit, requestParameters.sort, requestParameters.searchType, requestParameters.keyword, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 특정 커뮤니티(카테고리) 게시글 목록 조회
         * @param {CommunitiesApiCommunityControllerGetPostsByCommunityUuidRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communityControllerGetPostsByCommunityUuid(requestParameters: CommunitiesApiCommunityControllerGetPostsByCommunityUuidRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetPostsOkDto> {
            return localVarFp.communityControllerGetPostsByCommunityUuid(requestParameters.communityUuid, requestParameters.page, requestParameters.limit, requestParameters.sort, requestParameters.searchType, requestParameters.keyword, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 커뮤니티 추천 게시글 목록 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communityControllerGetRecommendedPosts(options?: RawAxiosRequestConfig): AxiosPromise<GetRecommendedPostsOkDto> {
            return localVarFp.communityControllerGetRecommendedPosts(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 커뮤니티 같은 카테고리의 게시글 3개 조회
         * @param {CommunitiesApiCommunityControllerGetRelatedPostsByPostUuidRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communityControllerGetRelatedPostsByPostUuid(requestParameters: CommunitiesApiCommunityControllerGetRelatedPostsByPostUuidRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetRelatedPostsByPostUuidOkDto> {
            return localVarFp.communityControllerGetRelatedPostsByPostUuid(requestParameters.communityPostUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 커뮤니티 게시글 댓글 수정
         * @param {CommunitiesApiCommunityControllerPatchCommentByCommentUuidRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communityControllerPatchCommentByCommentUuid(requestParameters: CommunitiesApiCommunityControllerPatchCommentByCommentUuidRequest, options?: RawAxiosRequestConfig): AxiosPromise<PatchCommentByCommentUuidOkDto> {
            return localVarFp.communityControllerPatchCommentByCommentUuid(requestParameters.communityPostCommentUuid, requestParameters.patchCommentByCommentUuidReqBodyDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 커뮤니티 게시글 수정
         * @param {CommunitiesApiCommunityControllerPatchPostByPostUuidRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communityControllerPatchPostByPostUuid(requestParameters: CommunitiesApiCommunityControllerPatchPostByPostUuidRequest, options?: RawAxiosRequestConfig): AxiosPromise<PatchPostByPostUuidOkDto> {
            return localVarFp.communityControllerPatchPostByPostUuid(requestParameters.communityPostUuid, requestParameters.patchPostByPostUuidReqBodyDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 커뮤니티 게시글 댓글 생성
         * @param {CommunitiesApiCommunityControllerPostCommentByPostUuidRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communityControllerPostCommentByPostUuid(requestParameters: CommunitiesApiCommunityControllerPostCommentByPostUuidRequest, options?: RawAxiosRequestConfig): AxiosPromise<PostCommentByPostUuidCreatedDto> {
            return localVarFp.communityControllerPostCommentByPostUuid(requestParameters.communityPostUuid, requestParameters.postCommentByPostUuidReqBodyDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 커뮤니티 게시글 좋아요 생성
         * @param {CommunitiesApiCommunityControllerPostLikeByPostUuidRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communityControllerPostLikeByPostUuid(requestParameters: CommunitiesApiCommunityControllerPostLikeByPostUuidRequest, options?: RawAxiosRequestConfig): AxiosPromise<PostLikeByPostUuidCreatedDto> {
            return localVarFp.communityControllerPostLikeByPostUuid(requestParameters.communityPostUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 커뮤니티 게시글 생성
         * @param {CommunitiesApiCommunityControllerPostPostByCommunityUuidRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communityControllerPostPostByCommunityUuid(requestParameters: CommunitiesApiCommunityControllerPostPostByCommunityUuidRequest, options?: RawAxiosRequestConfig): AxiosPromise<PostPostByCommunityUuidCreatedDto> {
            return localVarFp.communityControllerPostPostByCommunityUuid(requestParameters.communityUuid, requestParameters.postPostByCommunityUuidReqBodyDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for communityControllerDeleteCommentByCommentUuid operation in CommunitiesApi.
 * @export
 * @interface CommunitiesApiCommunityControllerDeleteCommentByCommentUuidRequest
 */
export interface CommunitiesApiCommunityControllerDeleteCommentByCommentUuidRequest {
    /**
     * 댓글 uuid
     * @type {string}
     * @memberof CommunitiesApiCommunityControllerDeleteCommentByCommentUuid
     */
    readonly communityPostCommentUuid: string
}

/**
 * Request parameters for communityControllerDeleteLikeByPostUuid operation in CommunitiesApi.
 * @export
 * @interface CommunitiesApiCommunityControllerDeleteLikeByPostUuidRequest
 */
export interface CommunitiesApiCommunityControllerDeleteLikeByPostUuidRequest {
    /**
     * 게시글 uuid
     * @type {string}
     * @memberof CommunitiesApiCommunityControllerDeleteLikeByPostUuid
     */
    readonly communityPostUuid: string
}

/**
 * Request parameters for communityControllerDeletePostByPostUuid operation in CommunitiesApi.
 * @export
 * @interface CommunitiesApiCommunityControllerDeletePostByPostUuidRequest
 */
export interface CommunitiesApiCommunityControllerDeletePostByPostUuidRequest {
    /**
     * 게시글 uuid
     * @type {string}
     * @memberof CommunitiesApiCommunityControllerDeletePostByPostUuid
     */
    readonly communityPostUuid: string
}

/**
 * Request parameters for communityControllerGetCommentsByPostUuid operation in CommunitiesApi.
 * @export
 * @interface CommunitiesApiCommunityControllerGetCommentsByPostUuidRequest
 */
export interface CommunitiesApiCommunityControllerGetCommentsByPostUuidRequest {
    /**
     * 게시글 uuid
     * @type {string}
     * @memberof CommunitiesApiCommunityControllerGetCommentsByPostUuid
     */
    readonly communityPostUuid: string
}

/**
 * Request parameters for communityControllerGetCommentsByUserUuid operation in CommunitiesApi.
 * @export
 * @interface CommunitiesApiCommunityControllerGetCommentsByUserUuidRequest
 */
export interface CommunitiesApiCommunityControllerGetCommentsByUserUuidRequest {
    /**
     * 현재 페이지
     * @type {number}
     * @memberof CommunitiesApiCommunityControllerGetCommentsByUserUuid
     */
    readonly page?: number
}

/**
 * Request parameters for communityControllerGetLatestLikesByPostUuid operation in CommunitiesApi.
 * @export
 * @interface CommunitiesApiCommunityControllerGetLatestLikesByPostUuidRequest
 */
export interface CommunitiesApiCommunityControllerGetLatestLikesByPostUuidRequest {
    /**
     * 게시글 uuid
     * @type {string}
     * @memberof CommunitiesApiCommunityControllerGetLatestLikesByPostUuid
     */
    readonly communityPostUuid: string
}

/**
 * Request parameters for communityControllerGetLikeStatusByPostUuid operation in CommunitiesApi.
 * @export
 * @interface CommunitiesApiCommunityControllerGetLikeStatusByPostUuidRequest
 */
export interface CommunitiesApiCommunityControllerGetLikeStatusByPostUuidRequest {
    /**
     * 게시글 uuid
     * @type {string}
     * @memberof CommunitiesApiCommunityControllerGetLikeStatusByPostUuid
     */
    readonly communityPostUuid: string
}

/**
 * Request parameters for communityControllerGetPostByPostUuid operation in CommunitiesApi.
 * @export
 * @interface CommunitiesApiCommunityControllerGetPostByPostUuidRequest
 */
export interface CommunitiesApiCommunityControllerGetPostByPostUuidRequest {
    /**
     * 게시글 uuid
     * @type {string}
     * @memberof CommunitiesApiCommunityControllerGetPostByPostUuid
     */
    readonly communityPostUuid: string
}

/**
 * Request parameters for communityControllerGetPosts operation in CommunitiesApi.
 * @export
 * @interface CommunitiesApiCommunityControllerGetPostsRequest
 */
export interface CommunitiesApiCommunityControllerGetPostsRequest {
    /**
     * 현재 페이지
     * @type {number}
     * @memberof CommunitiesApiCommunityControllerGetPosts
     */
    readonly page?: number

    /**
     * 한 페이지에 보여줄 데이터 수
     * @type {number}
     * @memberof CommunitiesApiCommunityControllerGetPosts
     */
    readonly limit?: number

    /**
     * 정렬 기준
     * @type {'latest' | 'comment' | 'like'}
     * @memberof CommunitiesApiCommunityControllerGetPosts
     */
    readonly sort?: CommunityControllerGetPostsSortEnum

    /**
     * 검색 타입
     * @type {'title' | 'nickname'}
     * @memberof CommunitiesApiCommunityControllerGetPosts
     */
    readonly searchType?: CommunityControllerGetPostsSearchTypeEnum

    /**
     * 검색어
     * @type {string}
     * @memberof CommunitiesApiCommunityControllerGetPosts
     */
    readonly keyword?: string
}

/**
 * Request parameters for communityControllerGetPostsByCommunityUuid operation in CommunitiesApi.
 * @export
 * @interface CommunitiesApiCommunityControllerGetPostsByCommunityUuidRequest
 */
export interface CommunitiesApiCommunityControllerGetPostsByCommunityUuidRequest {
    /**
     * 커뮤니티 uuid(카테고리)
     * @type {string}
     * @memberof CommunitiesApiCommunityControllerGetPostsByCommunityUuid
     */
    readonly communityUuid: string

    /**
     * 현재 페이지
     * @type {number}
     * @memberof CommunitiesApiCommunityControllerGetPostsByCommunityUuid
     */
    readonly page?: number

    /**
     * 한 페이지에 보여줄 데이터 수
     * @type {number}
     * @memberof CommunitiesApiCommunityControllerGetPostsByCommunityUuid
     */
    readonly limit?: number

    /**
     * 정렬 기준
     * @type {'latest' | 'comment' | 'like'}
     * @memberof CommunitiesApiCommunityControllerGetPostsByCommunityUuid
     */
    readonly sort?: CommunityControllerGetPostsByCommunityUuidSortEnum

    /**
     * 검색 타입
     * @type {'title' | 'nickname'}
     * @memberof CommunitiesApiCommunityControllerGetPostsByCommunityUuid
     */
    readonly searchType?: CommunityControllerGetPostsByCommunityUuidSearchTypeEnum

    /**
     * 검색어
     * @type {string}
     * @memberof CommunitiesApiCommunityControllerGetPostsByCommunityUuid
     */
    readonly keyword?: string
}

/**
 * Request parameters for communityControllerGetRelatedPostsByPostUuid operation in CommunitiesApi.
 * @export
 * @interface CommunitiesApiCommunityControllerGetRelatedPostsByPostUuidRequest
 */
export interface CommunitiesApiCommunityControllerGetRelatedPostsByPostUuidRequest {
    /**
     * 게시글 uuid
     * @type {string}
     * @memberof CommunitiesApiCommunityControllerGetRelatedPostsByPostUuid
     */
    readonly communityPostUuid: string
}

/**
 * Request parameters for communityControllerPatchCommentByCommentUuid operation in CommunitiesApi.
 * @export
 * @interface CommunitiesApiCommunityControllerPatchCommentByCommentUuidRequest
 */
export interface CommunitiesApiCommunityControllerPatchCommentByCommentUuidRequest {
    /**
     * 댓글 uuid
     * @type {string}
     * @memberof CommunitiesApiCommunityControllerPatchCommentByCommentUuid
     */
    readonly communityPostCommentUuid: string

    /**
     * 
     * @type {PatchCommentByCommentUuidReqBodyDto}
     * @memberof CommunitiesApiCommunityControllerPatchCommentByCommentUuid
     */
    readonly patchCommentByCommentUuidReqBodyDto: PatchCommentByCommentUuidReqBodyDto
}

/**
 * Request parameters for communityControllerPatchPostByPostUuid operation in CommunitiesApi.
 * @export
 * @interface CommunitiesApiCommunityControllerPatchPostByPostUuidRequest
 */
export interface CommunitiesApiCommunityControllerPatchPostByPostUuidRequest {
    /**
     * 게시글 uuid
     * @type {string}
     * @memberof CommunitiesApiCommunityControllerPatchPostByPostUuid
     */
    readonly communityPostUuid: string

    /**
     * 
     * @type {PatchPostByPostUuidReqBodyDto}
     * @memberof CommunitiesApiCommunityControllerPatchPostByPostUuid
     */
    readonly patchPostByPostUuidReqBodyDto: PatchPostByPostUuidReqBodyDto
}

/**
 * Request parameters for communityControllerPostCommentByPostUuid operation in CommunitiesApi.
 * @export
 * @interface CommunitiesApiCommunityControllerPostCommentByPostUuidRequest
 */
export interface CommunitiesApiCommunityControllerPostCommentByPostUuidRequest {
    /**
     * 게시글 uuid
     * @type {string}
     * @memberof CommunitiesApiCommunityControllerPostCommentByPostUuid
     */
    readonly communityPostUuid: string

    /**
     * 
     * @type {PostCommentByPostUuidReqBodyDto}
     * @memberof CommunitiesApiCommunityControllerPostCommentByPostUuid
     */
    readonly postCommentByPostUuidReqBodyDto: PostCommentByPostUuidReqBodyDto
}

/**
 * Request parameters for communityControllerPostLikeByPostUuid operation in CommunitiesApi.
 * @export
 * @interface CommunitiesApiCommunityControllerPostLikeByPostUuidRequest
 */
export interface CommunitiesApiCommunityControllerPostLikeByPostUuidRequest {
    /**
     * 게시글 uuid
     * @type {string}
     * @memberof CommunitiesApiCommunityControllerPostLikeByPostUuid
     */
    readonly communityPostUuid: string
}

/**
 * Request parameters for communityControllerPostPostByCommunityUuid operation in CommunitiesApi.
 * @export
 * @interface CommunitiesApiCommunityControllerPostPostByCommunityUuidRequest
 */
export interface CommunitiesApiCommunityControllerPostPostByCommunityUuidRequest {
    /**
     * 커뮤니티 uuid(카테고리)
     * @type {string}
     * @memberof CommunitiesApiCommunityControllerPostPostByCommunityUuid
     */
    readonly communityUuid: string

    /**
     * 
     * @type {PostPostByCommunityUuidReqBodyDto}
     * @memberof CommunitiesApiCommunityControllerPostPostByCommunityUuid
     */
    readonly postPostByCommunityUuidReqBodyDto: PostPostByCommunityUuidReqBodyDto
}

/**
 * CommunitiesApi - object-oriented interface
 * @export
 * @class CommunitiesApi
 * @extends {BaseAPI}
 */
export class CommunitiesApi extends BaseAPI {
    /**
     * 
     * @summary 커뮤니티 게시글 댓글 삭제
     * @param {CommunitiesApiCommunityControllerDeleteCommentByCommentUuidRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommunitiesApi
     */
    public communityControllerDeleteCommentByCommentUuid(requestParameters: CommunitiesApiCommunityControllerDeleteCommentByCommentUuidRequest, options?: RawAxiosRequestConfig) {
        return CommunitiesApiFp(this.configuration).communityControllerDeleteCommentByCommentUuid(requestParameters.communityPostCommentUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 커뮤니티 게시글 좋아요 삭제
     * @param {CommunitiesApiCommunityControllerDeleteLikeByPostUuidRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommunitiesApi
     */
    public communityControllerDeleteLikeByPostUuid(requestParameters: CommunitiesApiCommunityControllerDeleteLikeByPostUuidRequest, options?: RawAxiosRequestConfig) {
        return CommunitiesApiFp(this.configuration).communityControllerDeleteLikeByPostUuid(requestParameters.communityPostUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 커뮤니티 게시글 삭제
     * @param {CommunitiesApiCommunityControllerDeletePostByPostUuidRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommunitiesApi
     */
    public communityControllerDeletePostByPostUuid(requestParameters: CommunitiesApiCommunityControllerDeletePostByPostUuidRequest, options?: RawAxiosRequestConfig) {
        return CommunitiesApiFp(this.configuration).communityControllerDeletePostByPostUuid(requestParameters.communityPostUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 커뮤니티 베스트 꿀팁 게시글 목록 조회
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommunitiesApi
     */
    public communityControllerGetBestTipPosts(options?: RawAxiosRequestConfig) {
        return CommunitiesApiFp(this.configuration).communityControllerGetBestTipPosts(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 커뮤니티 게시글 댓글 목록 조회
     * @param {CommunitiesApiCommunityControllerGetCommentsByPostUuidRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommunitiesApi
     */
    public communityControllerGetCommentsByPostUuid(requestParameters: CommunitiesApiCommunityControllerGetCommentsByPostUuidRequest, options?: RawAxiosRequestConfig) {
        return CommunitiesApiFp(this.configuration).communityControllerGetCommentsByPostUuid(requestParameters.communityPostUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 커뮤니티 게시글 본인 댓글 조회
     * @param {CommunitiesApiCommunityControllerGetCommentsByUserUuidRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommunitiesApi
     */
    public communityControllerGetCommentsByUserUuid(requestParameters: CommunitiesApiCommunityControllerGetCommentsByUserUuidRequest = {}, options?: RawAxiosRequestConfig) {
        return CommunitiesApiFp(this.configuration).communityControllerGetCommentsByUserUuid(requestParameters.page, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 커뮤니티 카테고리 목록 조회
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommunitiesApi
     */
    public communityControllerGetCommunities(options?: RawAxiosRequestConfig) {
        return CommunitiesApiFp(this.configuration).communityControllerGetCommunities(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 커뮤니티 게시글 최근 3개 좋아요 목록 조회
     * @param {CommunitiesApiCommunityControllerGetLatestLikesByPostUuidRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommunitiesApi
     */
    public communityControllerGetLatestLikesByPostUuid(requestParameters: CommunitiesApiCommunityControllerGetLatestLikesByPostUuidRequest, options?: RawAxiosRequestConfig) {
        return CommunitiesApiFp(this.configuration).communityControllerGetLatestLikesByPostUuid(requestParameters.communityPostUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 커뮤니티 게시글에 본인이 좋아요 했는지 확인
     * @param {CommunitiesApiCommunityControllerGetLikeStatusByPostUuidRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommunitiesApi
     */
    public communityControllerGetLikeStatusByPostUuid(requestParameters: CommunitiesApiCommunityControllerGetLikeStatusByPostUuidRequest, options?: RawAxiosRequestConfig) {
        return CommunitiesApiFp(this.configuration).communityControllerGetLikeStatusByPostUuid(requestParameters.communityPostUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 커뮤니티 상단고정 게시글 목록 조회
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommunitiesApi
     */
    public communityControllerGetPinnedPosts(options?: RawAxiosRequestConfig) {
        return CommunitiesApiFp(this.configuration).communityControllerGetPinnedPosts(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 커뮤니티 인기 게시글 목록 조회
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommunitiesApi
     */
    public communityControllerGetPopularPosts(options?: RawAxiosRequestConfig) {
        return CommunitiesApiFp(this.configuration).communityControllerGetPopularPosts(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 커뮤니티 게시글 조회
     * @param {CommunitiesApiCommunityControllerGetPostByPostUuidRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommunitiesApi
     */
    public communityControllerGetPostByPostUuid(requestParameters: CommunitiesApiCommunityControllerGetPostByPostUuidRequest, options?: RawAxiosRequestConfig) {
        return CommunitiesApiFp(this.configuration).communityControllerGetPostByPostUuid(requestParameters.communityPostUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 커뮤니티 게시글 목록 조회
     * @param {CommunitiesApiCommunityControllerGetPostsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommunitiesApi
     */
    public communityControllerGetPosts(requestParameters: CommunitiesApiCommunityControllerGetPostsRequest = {}, options?: RawAxiosRequestConfig) {
        return CommunitiesApiFp(this.configuration).communityControllerGetPosts(requestParameters.page, requestParameters.limit, requestParameters.sort, requestParameters.searchType, requestParameters.keyword, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 특정 커뮤니티(카테고리) 게시글 목록 조회
     * @param {CommunitiesApiCommunityControllerGetPostsByCommunityUuidRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommunitiesApi
     */
    public communityControllerGetPostsByCommunityUuid(requestParameters: CommunitiesApiCommunityControllerGetPostsByCommunityUuidRequest, options?: RawAxiosRequestConfig) {
        return CommunitiesApiFp(this.configuration).communityControllerGetPostsByCommunityUuid(requestParameters.communityUuid, requestParameters.page, requestParameters.limit, requestParameters.sort, requestParameters.searchType, requestParameters.keyword, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 커뮤니티 추천 게시글 목록 조회
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommunitiesApi
     */
    public communityControllerGetRecommendedPosts(options?: RawAxiosRequestConfig) {
        return CommunitiesApiFp(this.configuration).communityControllerGetRecommendedPosts(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 커뮤니티 같은 카테고리의 게시글 3개 조회
     * @param {CommunitiesApiCommunityControllerGetRelatedPostsByPostUuidRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommunitiesApi
     */
    public communityControllerGetRelatedPostsByPostUuid(requestParameters: CommunitiesApiCommunityControllerGetRelatedPostsByPostUuidRequest, options?: RawAxiosRequestConfig) {
        return CommunitiesApiFp(this.configuration).communityControllerGetRelatedPostsByPostUuid(requestParameters.communityPostUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 커뮤니티 게시글 댓글 수정
     * @param {CommunitiesApiCommunityControllerPatchCommentByCommentUuidRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommunitiesApi
     */
    public communityControllerPatchCommentByCommentUuid(requestParameters: CommunitiesApiCommunityControllerPatchCommentByCommentUuidRequest, options?: RawAxiosRequestConfig) {
        return CommunitiesApiFp(this.configuration).communityControllerPatchCommentByCommentUuid(requestParameters.communityPostCommentUuid, requestParameters.patchCommentByCommentUuidReqBodyDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 커뮤니티 게시글 수정
     * @param {CommunitiesApiCommunityControllerPatchPostByPostUuidRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommunitiesApi
     */
    public communityControllerPatchPostByPostUuid(requestParameters: CommunitiesApiCommunityControllerPatchPostByPostUuidRequest, options?: RawAxiosRequestConfig) {
        return CommunitiesApiFp(this.configuration).communityControllerPatchPostByPostUuid(requestParameters.communityPostUuid, requestParameters.patchPostByPostUuidReqBodyDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 커뮤니티 게시글 댓글 생성
     * @param {CommunitiesApiCommunityControllerPostCommentByPostUuidRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommunitiesApi
     */
    public communityControllerPostCommentByPostUuid(requestParameters: CommunitiesApiCommunityControllerPostCommentByPostUuidRequest, options?: RawAxiosRequestConfig) {
        return CommunitiesApiFp(this.configuration).communityControllerPostCommentByPostUuid(requestParameters.communityPostUuid, requestParameters.postCommentByPostUuidReqBodyDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 커뮤니티 게시글 좋아요 생성
     * @param {CommunitiesApiCommunityControllerPostLikeByPostUuidRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommunitiesApi
     */
    public communityControllerPostLikeByPostUuid(requestParameters: CommunitiesApiCommunityControllerPostLikeByPostUuidRequest, options?: RawAxiosRequestConfig) {
        return CommunitiesApiFp(this.configuration).communityControllerPostLikeByPostUuid(requestParameters.communityPostUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 커뮤니티 게시글 생성
     * @param {CommunitiesApiCommunityControllerPostPostByCommunityUuidRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommunitiesApi
     */
    public communityControllerPostPostByCommunityUuid(requestParameters: CommunitiesApiCommunityControllerPostPostByCommunityUuidRequest, options?: RawAxiosRequestConfig) {
        return CommunitiesApiFp(this.configuration).communityControllerPostPostByCommunityUuid(requestParameters.communityUuid, requestParameters.postPostByCommunityUuidReqBodyDto, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const CommunityControllerGetPostsSortEnum = {
    Latest: 'latest',
    Comment: 'comment',
    Like: 'like'
} as const;
export type CommunityControllerGetPostsSortEnum = typeof CommunityControllerGetPostsSortEnum[keyof typeof CommunityControllerGetPostsSortEnum];
/**
 * @export
 */
export const CommunityControllerGetPostsSearchTypeEnum = {
    Title: 'title',
    Nickname: 'nickname'
} as const;
export type CommunityControllerGetPostsSearchTypeEnum = typeof CommunityControllerGetPostsSearchTypeEnum[keyof typeof CommunityControllerGetPostsSearchTypeEnum];
/**
 * @export
 */
export const CommunityControllerGetPostsByCommunityUuidSortEnum = {
    Latest: 'latest',
    Comment: 'comment',
    Like: 'like'
} as const;
export type CommunityControllerGetPostsByCommunityUuidSortEnum = typeof CommunityControllerGetPostsByCommunityUuidSortEnum[keyof typeof CommunityControllerGetPostsByCommunityUuidSortEnum];
/**
 * @export
 */
export const CommunityControllerGetPostsByCommunityUuidSearchTypeEnum = {
    Title: 'title',
    Nickname: 'nickname'
} as const;
export type CommunityControllerGetPostsByCommunityUuidSearchTypeEnum = typeof CommunityControllerGetPostsByCommunityUuidSearchTypeEnum[keyof typeof CommunityControllerGetPostsByCommunityUuidSearchTypeEnum];
